export enum AlterationStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
